import React, { Component } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import UserInfoBlock from './UserInfoBlock';
import CommentsIn from '../../../../../components/Comment/ReducerWrappers/CommentsIn';
import CommentsOut from '../../../../../components/Comment/ReducerWrappers/CommentsOut';

import TasksListByOwnerId from '../../../../../components/Tasks/ReducerWrappers/TasksListByOwnerId';

// eslint-disable-next-line react/prefer-stateless-function
class UserProfile extends Component {
  render() {
    return (
      <React.Fragment>
        <UserInfoBlock userInfo={this.props.userInfo} />
        <Switch>
          <Route
            exact
            path={`/users/profile/${this.props.userInfo.id}`}
            render={() => (
              <Redirect
                from="/"
                to={`/users/profile/${this.props.userInfo.id}/comments`}
              />
            )}
          />
          <Route
            path={`/users/profile/${this.props.userInfo.id}/comments`}
            render={() => (
              <CommentsIn
                modelClass="User"
                modelId={this.props.userInfo.id}
                commentsOwnerId={this.props.userInfo.id}
                commentsInStat={this.props.userInfo.countsStat.commentsIn}
              />
            )}
          />
          <Route
            path={`/users/profile/${this.props.userInfo.id}/tasks`}
            render={() => (
              <TasksListByOwnerId userId={this.props.userInfo.id} />
            )}
          />
          <Route
            path={`/users/profile/${this.props.userInfo.id}/comments-from-user`}
            render={() => (
              <CommentsOut
                userId={this.props.userInfo.id}
                commentsOwnerId={this.props.userInfo.id}
                commentsOutStat={this.props.userInfo.countsStat.commentsOut}
              />
            )}
          />
        </Switch>
      </React.Fragment>
    );
  }
}

UserProfile.propTypes = {
  userInfo: PropTypes.shape({
    id: PropTypes.number.isRequired,
    countsStat: PropTypes.shape({
      commentsIn: PropTypes.shape({
        dislikes: PropTypes.number.isRequired,
        neutral: PropTypes.number.isRequired,
        likes: PropTypes.number.isRequired,
        total: PropTypes.number.isRequired
      }).isRequired,
      commentsOut: PropTypes.shape({
        dislikes: PropTypes.number.isRequired,
        neutral: PropTypes.number.isRequired,
        likes: PropTypes.number.isRequired,
        total: PropTypes.number.isRequired
      }).isRequired
    })
  }).isRequired
};

export default withRouter(UserProfile);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Users/UserProfile/UserProfile.js